import { createFileRoute, redirect } from "@tanstack/react-router";

// Old address: always show the current public grants page.
export const Route = createFileRoute("/en/panel/grants")({
  beforeLoad: () => {
    throw redirect({ to: "/en/resources/subsidies", statusCode: 301 });
  },
});
